import React, { Component, Fragment } from "react";
import { Link } from "react-router";
import { connect } from "react-redux";
import BacktestService from "../../service/backtest.service";
import { browserHistory } from "react-router";
import Comptab from "../../components/PortfolioDashboard/navigationPages/Component page/component.jsx";
import Performance from "../../components/PortfolioDashboard/navigationPages/performance/performance";
import Statistics from "../../components/PortfolioDashboard/navigationPages/statistics/statistics";
import PortfolioComparison from "./dashboardComponents/PortfolioComparison";
import RebalanceDashboard from "../PortfolioDashboard/navigationPages/Rebalance/rebalance";
import CompareOrig from "../PortfolioDashboard/navigationPages/compareORIG/CompareOrig";
import Backtest from "../../components/PortfolioDashboard/navigationPages/backtest/backtest";
import Simulation from "../PortfolioDashboard/navigationPages/simulation";
// import Attribution from "../../components/PortfolioDashboard/navigationPages/attribution/attribution";
import FailedToLoadData from "../common/errorBoundary/failedToLoadData";
import SpinnerWithCard from "../common/spinnerWithCard";
import Spinner from "../common/spinner";
import helper from "./helper.modifyPortfolio";
import "./portfolionav.scss";
import "./portfolio.scss";

class Dashboard extends Component {
  state = {
    spinner: true,
    failedtoLoadData: false,
    getBacktest: [],
    getPerfHistMetrics: [],
    getRiskStatistics: [],
    id: "",
    typeName: "Benchmark",
    headSection_height: "130px",
    navBar_colapse: "navbar-collapse collapse",
    // orig tab
    checkORIG_Present: false,
    origOBJ: [],
    live: [],
    myPortfolios: [],
    last_dt: "",
    simulations: undefined,
    displayAutoCompleteOption: false,
    ajax_in_progress: false,
    autoCompleteData: [],
    resetBenchmarkData: false,
    inputFieldValue: "",
    subHeadingSpinner: false,
  };

  async componentWillMount() {
    const { list_of_myPortfolios, setMyPortfolios } = this.props;

    // setting list of myportfolios if its empty on refresh setting it from location history
    if (list_of_myPortfolios.length == 0) {
      setMyPortfolios(this.props.location.state.sortedData);
    }

    let _user_preferences = window.localStorage._user_preferences
      ? JSON.parse(window.localStorage._user_preferences)
      : false;

    if (_user_preferences) {
      let simulations = _user_preferences["simulations"];

      this.setState({
        simulations: simulations,
      });
    }
    // orig portfolio api call based on client portfolio id in my_portfolios - scenarios list
    const { client_portfolio_id, benchmark_name } = this.props.location.state;
    if (benchmark_name && client_portfolio_id) {
      this.props.setBenchmarkName(benchmark_name);
    }
    if (client_portfolio_id) {
      this.props.setOrigPortfolioDisplay(true);
      try {
        await BacktestService.getBacktest(
          `${client_portfolio_id}`,
          "DUMMY",
          "BACKTEST"
        ).then((res) => {
          if (res) {
            this.props.setClientBacktestData(res);

            // last dt
            let data = res.getPortfolioData;
            if (data && data.length) {
              let last_dt = data[data.length - 1]["dt"];
              this.setState({
                last_dt,
              });
            }
          }
        });
      } catch (error) {
        console.log("getBacktest", error);
      }
      try {
        await BacktestService.getRiskStatistics(
          `${client_portfolio_id}`,
          `BACKTEST`
        ).then((res) => {
          if (res) {
            this.props.setAnalyzeAnalysisRiskStatistics(res);
          }
        });
      } catch (error) {
        console.log("getRiskStatistics", error);
      }
      try {
        await BacktestService.getPerfHistMetrics(
          `${client_portfolio_id}`,
          `BACKTEST`
        ).then((res) => {
          if (res) {
            this.props.setAnalyzeAnalysisPerfHistmetrics(res);
          }
        });
      } catch (error) {
        console.log("getPerfHistMetrics", error);
      }
    }
  }
  async componentDidMount() {
    let {
      foo,
      type,
      benchmark,
      typeName,
      subHeading,
    } = this.props.location.state;
    if (typeName) {
      this.setState({
        typeName: typeName,
      });
    }
    this.setState({
      inputFieldValue: subHeading,
    });
    const filterByName = (item) => {
      if (item.scenario_name) {
        return true;
      }
      return false;
    };

    try {
      // ** dashboard portfolios list (live & backtest)  ***
      await BacktestService.getScenariosNew("LIVE").then((res) => {
        if (res) {
          let live = helper.filterData({ data: res });
          this.setState({
            live: live.filter(filterByName),
          });
        }
      });
      await BacktestService.getScenariosNew("BACKTEST").then((res) => {
        if (res) {
          var { heading } = this.props.location.state;

          let benchmark = helper.filterData({ data: res });

          let concated = this.state.live.concat(benchmark);
          let data = concated.filter(filterByName);
          this.setState(
            {
              myPortfolios: data,
            },
            () => {
              this.checkORIG_Present(data, heading);
            }
          );
        }
      });

      await BacktestService.getBacktest(
        `${foo}`,
        `${benchmark}`,
        `${type}`
      ).then((res) => {
        if (res) {
          // last dt
          let data = res.getPortfolioData;
          if (data && data.length) {
            let last_dt = data[data.length - 1]["dt"];
            this.setState({
              last_dt,
            });
          }

          this.setState({
            getBacktest: res,
            spinner: false,
            failedtoLoadData: false,
          });
        }
      });
    } catch (err) {
      this.setState({
        spinner: false,
        failedtoLoadData: true,
      });
    }
    await BacktestService.getPerfHistMetrics(`${foo}`, `${type}`).then(
      (res) => {
        if (res) {
          this.setState({
            getPerfHistMetrics: res,
          });
        }
      }
    );
    await BacktestService.getRiskStatistics(`${foo}`, `${type}`).then((res) => {
      if (res) {
        this.setState({
          getRiskStatistics: res,
        });
      }
    });
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillReceiveProps(nextProps) {
    let _user_preferences = window.localStorage._user_preferences
      ? JSON.parse(window.localStorage._user_preferences)
      : false;

    if (_user_preferences) {
      let simulations = _user_preferences["simulations"];

      this.setState({
        simulations: simulations,
      });
    }
  }
  componentWillUnmount() {
    document.addEventListener("click", this.handleClickOutside);
  }
  // rendering Backtest tab on condition
  render_Backtest() {
    let { foo, type, benchmark } = this.props.location.state;
    if (type === "BACKTEST") {
      return (
        <div id="Backtest" className="tab-pane fade">
          {Object.keys(this.state.getBacktest).length ? (
            <Backtest
              scenario_id={foo}
              type={type}
              benchmark={benchmark}
              {...this.props.location.state}
              {...this.state}
            />
          ) : null}
        </div>
      );
    }
    return null;
  }
  pillBacktest() {
    let { type } = this.props.location.state;
    if (type === "BACKTEST") {
      return (
        <li>
          <a data-toggle="tab" href="#Backtest">
            Backtest
          </a>
        </li>
      );
    }
    return null;
  }

  pill_portfolioCompare = () => {
    const { iqcioDrilldown } = this.props.comparePortfolio;
    return (
      <Fragment>
        {iqcioDrilldown.length ? (
          // <li className={iqcioDrilldown.length ? "active" : " "}>
          <li>
            <a data-toggle="tab" href="#portfolioComparison">
              Comparison
            </a>
          </li>
        ) : null}
      </Fragment>
    );
  };

  EditButton = () => {
    let { type } = this.props.location.state;
    if (type !== "BACKTEST") {
      return (
        <div className="navbtn_position">
          <ul className="list-inline">
            <li>
              <Link to="/create">
                <button className="custom_btn">
                  <i className="fa fa-pencil" />
                  Edit
                </button>
              </Link>
            </li>
          </ul>
        </div>
      );
    }
    return null;
  };

  collapseButtonHandler = () => {
    let c = this.state.navBar_colapse;
    if (c == "navbar-collapse collapse") {
      this.setState({
        navBar_colapse: "navbar-collapse collapse in",
        headSection_height: "350px",
      });
    } else {
      this.setState({
        navBar_colapse: "navbar-collapse collapse",
        headSection_height: "130px",
      });
    }
  };

  // check _orig present in data
  checkORIG_Present = (data, name) => {
    if (!name) return false;
    const Name = name.concat("_orig").toLowerCase();

    var filtered_data = data.filter(
      (e) => e.scenario_name.toLowerCase().indexOf(Name) !== -1
    );

    if (filtered_data.length > 0) {
      this.setState({
        origOBJ: filtered_data[0],
        checkORIG_Present: true,
      });

      return true;
    }
    // if (filtered_data.length > 0) {
    //   return true;
    // } else {
    //   return false;
    // }
  };

  contactAdmin = () => {
    alert("Please Contact Your Admin.");
  };
  modifyPortfolioHandler = () => {
    const {
      list_of_myPortfolios,
      setDirectReviewModelPortfolio,
      setBuildAPortfolioType,
      direct_review_portfolio,
    } = this.props;
    const { benchmark_name } = this.props.location.state;
    const scenario_id = this.props.location.state.foo;

    let filter_list_of_myPortfolio =
      list_of_myPortfolios &&
      list_of_myPortfolios.filter((e) => e.scenario_id == scenario_id);
    let condition = filter_list_of_myPortfolio.length > 0;
    let client_id = filter_list_of_myPortfolio[0]["client_portfolio_id"];

    console.log(filter_list_of_myPortfolio, "filter_list_of_myPortfolio");

    // setting client portfolio if present in Benchmark data else using scenerio id
    if (condition && client_id) {
      this.props.setReviewClientPortfolioID(client_id);
    } else {
      this.props.setReviewClientPortfolioID(scenario_id);
    }
    let optimization_params = condition
      ? {
          [scenario_id]: {
            benchmark: filter_list_of_myPortfolio[0]["benchmark"],
            max_beta: filter_list_of_myPortfolio[0]["beta"],
            max_vol: filter_list_of_myPortfolio[0]["max_vol"],
            min_return: filter_list_of_myPortfolio[0]["min_return"],
            upper_bounds: filter_list_of_myPortfolio[0]["upper_bounds"],
          },
        }
      : {};
    //
    let asset_class = condition
      ? helper.modify_backtest_params({
          data: filter_list_of_myPortfolio[0]["fund_asset_class_focus"],
        })
      : [];
    let fund_type = condition
      ? helper.modify_backtest_params({
          data: filter_list_of_myPortfolio[0]["fund_type"],
        })
      : [];
    let overall_focus = condition
      ? helper.modify_backtest_params({
          data: filter_list_of_myPortfolio[0]["overall_focus"],
        })
      : [];
    let styles = condition
      ? helper.modify_backtest_params({
          name: "style",
          data: filter_list_of_myPortfolio[0]["style"],
        })
      : [];

    let absolute_flag = condition
      ? filter_list_of_myPortfolio[0]["absolute_flag"]
      : 0;

    if (
      filter_list_of_myPortfolio &&
      filter_list_of_myPortfolio[0] &&
      filter_list_of_myPortfolio[0].hasOwnProperty("portfolio_type") &&
      filter_list_of_myPortfolio[0]["portfolio_type"] &&
      filter_list_of_myPortfolio[0]["portfolio_type"] !== "CI"
    ) {
      this.props.resetBuildAPortfolio();
      this.props.setDirectReviewPortfolio(true);
      this.props.setBuildDirectReviewPortfolio({
        status: true,
        orig_id: filter_list_of_myPortfolio[0]["orig_scenario_id"],
        scenario_id: filter_list_of_myPortfolio[0]["scenario_id"],
        optimization_params,
        asset_class,
        fund_type,
        overall_focus,
        styles,
      });
      let type = filter_list_of_myPortfolio[0]["portfolio_type"];

      switch (type) {
        case "CP":
          setBuildAPortfolioType("customPortfolio");
          setTimeout(
            () => browserHistory.push("/buildPortfolio/customPortfolio"),
            100
          );

          break;
        case "MS":
          setBuildAPortfolioType("managerSelection");
          setTimeout(
            () => browserHistory.push("/buildPortfolio/managerSelection"),
            100
          );

          break;
        case "AA":
          setBuildAPortfolioType("assetAllocationFunds");
          setTimeout(
            () => browserHistory.push("/buildPortfolio/assetAllocationFunds"),
            100
          );

          break;
        case "MP":
          setBuildAPortfolioType("modelPortfolios");
          setTimeout(
            () => browserHistory.push("/buildPortfolio/modelPortfolios"),
            100
          );
          break;
        default:
          setBuildAPortfolioType("customPortfolio");
          setTimeout(
            () => browserHistory.push("/buildPortfolio/customPortfolio"),
            100
          );
      }
    } else {
      setTimeout(() => {
        this.props.setDirectReviewPortfolio(true);
        if (direct_review_portfolio) {
          this.props.resetBuildDirectReview();
        }

        setDirectReviewModelPortfolio({
          activePortfolioID: scenario_id,
          optimization_params,
          benchmark_name,
          asset_class,
          fund_type,
          overall_focus,
          styles,
          absolute_flag,
        });

        browserHistory.push("/create");
      }, 100);
    }
  };

  //==== input field (benchmark) search functions ====
  handleClickOutside = () => {
    let { displayAutoCompleteOption } = this.state;
    if (displayAutoCompleteOption) {
      setTimeout(() => {
        this.setState({
          displayAutoCompleteOption: false,
        });
      }, 100);
    }
  };
  searchHandler = (e) => {
    let { value } = e.target;
    this.setState(
      {
        inputFieldValue: value,
      },
      () => this.getAutoCompleteData()
    );
  };
  getAutoCompleteData = () => {
    let { inputFieldValue } = this.state;
    if (inputFieldValue.length >= 3) {
      if (!this.state.ajax_in_progress) {
        this.setState({
          ajax_in_progress: true,
        });
        BacktestService.getAutocompleteBenchmarks(`${inputFieldValue}`).then(
          (res) => {
            this.setState({
              ajax_in_progress: false,
            });
            if (res) {
              this.setState({
                autoCompleteData: res,
                displayAutoCompleteOption: true,
              });
            }
          }
        );
      }
    }
  };

  resetBenchmarkDataHandler = async () => {
    let { foo, benchmark, type, subHeading } = this.props.location.state;
    this.setState((prevState) => ({
      resetBenchmarkData: !prevState.resetBenchmarkData,
      inputFieldValue: subHeading,
      subHeadingSpinner: true,
    }));
    //ToDo : to reset benchmark data to its actual scenario id data
    // make api call here
    await BacktestService.getBacktestReload(`${foo}`, `${benchmark}`, `${type}`).then(
      (res) => {
        if (res) {
          // last dt
          let data = res.getPortfolioData;
          if (data && data.length) {
            let last_dt = data[data.length - 1]["dt"];
            this.setState({
              last_dt,
            });
          }
          this.setState({
            getBacktest: res,
          });
        }
      }
    );
    this.commonApiCalls({ scenario_id: foo, symbol: benchmark });
  };
  benchmarkListHandler = async (e) => {
    let { foo, type, benchmark, typeName } = this.props.location.state;
    const { autoCompleteData } = this.state;
    let index = e.target.getAttribute("index");
    let data = autoCompleteData[index];
    const { symbol } = autoCompleteData[index];

    this.setState({
      inputFieldValue: symbol,
      subHeadingSpinner: true,
    });
    // reload getBacktest api
    try {
      await BacktestService.getBacktestReload(`${foo}`, `${symbol}`).then(
        (res) => {
          if (res) {
            this.setState((prevState) => ({
              getBacktest: {
                ...prevState.getBacktest,
                getBenchmarkVami: res.getBenchmarkVami,
              },
            }));
          }
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({
        subHeadingSpinner: false,
      });
    }

    // make calls to other api's and set benchmark data to state
    await this.commonApiCalls({ scenario_id: foo, symbol });

    this.setState({
      resetBenchmarkData: true,
    });
    //need to make a call to the original benchmark reset at backend
    console.log("Time to reset benchmark...");

    BacktestService.getBacktestReload(`${foo}`, `${benchmark}`, `${type}`)

  };
  commonApiCalls = async ({ scenario_id, symbol }) => {
    try {
      await BacktestService.getRiskStatistics(
        `${scenario_id}`,
        `BACKTEST`
      ).then((res) => {
        if (res) {
          this.setState({
            getRiskStatistics: res,
          });
        }
      });
    } catch (error) {
      console.log("getRiskStatistics", error);
    } finally {
      this.setState({
        subHeadingSpinner: false,
      });
    }
    try {
      await BacktestService.getPerfHistMetrics(
        `${scenario_id}`,
        `BACKTEST`
      ).then((res) => {
        if (res) {
          this.setState({
            getPerfHistMetrics: res,
          });
        }
      });
    } catch (error) {
      console.log("getPerfHistMetrics", error);
    } finally {
      this.setState({
        subHeadingSpinner: false,
      });
    }
  };
  //-======================**==========================
  render() {
    var {
      foo,
      heading,
      subHeading,
      headingName,
      type,
      benchmark_name,
    } = this.props.location.state;
    var {
      getBacktest,
      getPerfHistMetrics,
      spinner,
      last_dt,
      getRiskStatistics,
      simulations,
      failedtoLoadData,
      displayAutoCompleteOption,
      autoCompleteData,
      resetBenchmarkData,
      inputFieldValue,
      subHeadingSpinner,
      typeName,
    } = this.state;
    const { iqcioDrilldown } = this.props.comparePortfolio;
    const { display_orig_portfolio, analyzeExistingActive } = this.props;

    return (
      <div className="page-content">
        <div
          className="head-section"
          style={{ height: this.state.headSection_height }}
        >
          <h1
            className={display_orig_portfolio ? "" : "text-uppercase"}
            style={{
              paddingTop: !subHeading ? "36px" : "",
            }}
          >
            {headingName === undefined ? heading : headingName}
          </h1>
          <div className="portfolio__searchBox">
            <div><b>BENCHMARK : </b>
              <input
                type="text"
                value={inputFieldValue}
                autoComplete="off"
                onChange={(e) => this.searchHandler(e)}
              />
              {subHeadingSpinner ? <Spinner size="medium" /> : null}
              {!subHeadingSpinner && resetBenchmarkData ? (
                <span
                  className="fa-stack fadeIn"
                  onClick={() => this.resetBenchmarkDataHandler()}
                >
                  <i className="fa fa-circle fa-stack-2x"></i>
                  <i
                    className="fa fa-undo fa-stack-1x fa-inverse"
                    style={{ color: "#fff" }}
                  ></i>
                </span>
              ) : null}
            </div>

            {displayAutoCompleteOption && autoCompleteData.length > 0 ? (
              <div>
                <ul>
                  {autoCompleteData.map((benchmark, id) => (
                    <li
                      key={id}
                      index={id}
                      onClick={(e) => this.benchmarkListHandler(e)}
                    >
                      {benchmark.symbol}
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>

          {/* <h6 className="text-uppercase">{subHeading}</h6> */}
          <div className="text-left">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <nav className="navbar" role="navigation">
                {/* <div class="container-fluid"> */}

                <div className="navbar-header">
                  <button
                    type="button"
                    className="navbar-toggle"
                    data-toggle="collapse"
                    data-target="#bs-navbar-collapse"
                    onClick={this.collapseButtonHandler}
                  >
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                </div>

                <div
                  className={`clearfix text-uppercase ${this.state.navBar_colapse}`}
                  id="collapse_pill_nav"
                >
                  {/* edit button towards right */}
                  {/* {this.EditButton()} */}
                  <ul className="nav nav-tabs top_nav head-menu">
                    {this.pill_portfolioCompare()}
                    <li className={iqcioDrilldown.length ? " " : "active"}>
                      {/* <li> */}
                      <a data-toggle="tab" href="#components">
                        Components
                      </a>
                    </li>
                    <li className={iqcioDrilldown.length ? "active" : " "}>
                      <a data-toggle="tab" href="#Performance">
                        Performance
                      </a>
                    </li>
                    {/* {this.pillBacktest()} */}
                    <li>
                      <a data-toggle="tab" href="#Statistics">
                        Statistics
                      </a>
                    </li>
                    {
                      //                    "BACKTEST"!==this.props.location.state.type ? (
                      //                        iqcioDrilldown.length <= 0 ? (
                      //                            <li>
                      //                              <a data-toggle="tab" href="#Rebalance">
                      //                                Rebalance
                      //                              </a>
                      //                            </li>
                      //                          ) : null
                      //                        ):null
                      <li>
                        <a data-toggle="tab" href="#Rebalance">
                          Rebalance
                        </a>
                      </li>
                    }
                    {/* <li>
                      <a data-toggle="tab" href="#Attribution">
                        Attribution
                      </a>
                    </li> */}
                    {/*<li>
                      <a data-toggle="tab" href="#Simulation">
                        Simulation
                      </a>
                    </li>*/}
                    {this.state.myPortfolios.length > 0 ? (
                      this.state.checkORIG_Present ? (
                        <li>
                          <a data-toggle="tab" href="#ComparePortfolio_new">
                            Compare Portfolio
                          </a>
                        </li>
                      ) : null
                    ) : null}
                    <li className="head-menu__modifyBtn">
                      <button
                        className="custom_btn"
                        onClick={() =>
                          simulations === false &&
                          process.env.NODE_ENV === "production"
                            ? this.contactAdmin()
                            : this.modifyPortfolioHandler()
                        }
                      >
                        Modify Portfolio
                      </button>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <div>
          <div className="tab-content">
            <PortfolioComparison
              comparePortfolio={this.props.comparePortfolio}
            />
            <div
              id="components"
              className={
                "tab-pane" +
                " " +
                (iqcioDrilldown.length ? "fade" : "fade in active")
              }
            >
              {/* <div id="components" className="tab-pane fade"> */}
              {spinner && <SpinnerWithCard />}
              {failedtoLoadData && <FailedToLoadData />}
              {Object.keys(getBacktest).length ? (
                <Comptab
                  scenario_id={foo}
                  getBacktest={getBacktest}
                  heading={heading}
                />
              ) : null}
            </div>
            <div
              id="Performance"
              className={
                "tab-pane" +
                " " +
                (iqcioDrilldown.length ? "fade in active" : "fade")
              }
            >
              {spinner && <SpinnerWithCard />}
              {failedtoLoadData && <FailedToLoadData />}
              {Object.keys(getBacktest).length &&
              getRiskStatistics &&
              getRiskStatistics.length > 0 &&
              getPerfHistMetrics ? (
                <Performance
                  scenario_id={foo}
                  getBacktest={getBacktest}
                  getPerfHistMetrics={getPerfHistMetrics}
                  benchmark={benchmark_name}
                  type="BACKTEST"
                  foo={foo}
                  origOBJ={this.state.origOBJ}
                  orig_lineChart_data={"portfolio"}
                  typeName={typeName}
                  getRiskStatistics={this.state.getRiskStatistics}
                  heading={heading}
                />
              ) : null}
            </div>

            {/* {this.render_Backtest()} */}

            <div id="Statistics" className="tab-pane fade">
              {spinner && <SpinnerWithCard />}
              {failedtoLoadData && <FailedToLoadData />}
              {Object.keys(getBacktest).length &&
              getRiskStatistics &&
              getRiskStatistics.length > 0 &&
              getPerfHistMetrics ? (
                <Statistics
                  scenario_id={foo}
                  getBacktest={getBacktest}
                  getPerfHistMetrics={getPerfHistMetrics}
                  lastTableDisplay={true}
                  benchmark={benchmark_name}
                  type="BACKTEST"
                  foo={foo}
                  origOBJ={this.state.origOBJ}
                  typeName={typeName}
                  getRiskStatistics={this.state.getRiskStatistics}
                  heading={heading}
                />
              ) : null}
            </div>
            {/* <div id="Attribution" className="tab-pane fade">
              {spinner ? (
                <WithCard>
                  <Spinner />{" "}
                </WithCard>
              ) : null}
              {Object.keys(getBacktest).length ? (
                <Attribution
                  scenario_id={foo}
                  {...this.props.location.state}
                  {...this.state}
                />
              ) : null}
            </div> */}
            {
              /*
                  "BACKTEST"!==this.props.location.state.type ? (
                  iqcioDrilldown.length <= 0 ? (
                    <div id="Rebalance" className="tab-pane fade">
                      {spinner ? <WithCard><Spinner /> </WithCard>: null}
                      {Object.keys(getBacktest).length ? (
                        <RebalanceDashboard
                          scenario_id={foo}
                          {...this.state}
                          {...this.props.location.state}
                        />
                      ) : null}
                    </div>) : null
                  ) : null
                  */
              <div id="Rebalance" className="tab-pane fade">
                {spinner && <SpinnerWithCard />}
                {Object.keys(getBacktest).length ? (
                  <RebalanceDashboard
                    scenario_id={foo}
                    heading={heading}
                    benchmark={benchmark_name}
                    getBacktest={getBacktest}
                  />
                ) : null}
              </div>
            }
            <div id="Simulation" className="tab-pane fade">
              {spinner && <SpinnerWithCard />}
              {failedtoLoadData && <FailedToLoadData />}
              {Object.keys(getBacktest).length && last_dt ? (
                <Simulation
                  scenarioID={foo}
                  dt={last_dt}
                  scenario_name={"testing"}
                  getBacktest={getBacktest}
                  type={type}
                  heading={heading}
                  analyzeExistingActive={analyzeExistingActive}
                />
              ) : null}
            </div>
            {this.state.myPortfolios.length > 0 ? (
              this.state.checkORIG_Present ? (
                <div id="ComparePortfolio_new" className="tab-pane fade">
                  {spinner && <SpinnerWithCard />}
                  {failedtoLoadData && <FailedToLoadData />}
                  {Object.keys(getBacktest).length ? (
                    <CompareOrig {...this.state} origOBJ={this.state.origOBJ} />
                  ) : null}
                </div>
              ) : null
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({
    compare: { comparePortfolio },
    create: {
      steps: {
        universeLite: { analyzeExistingActive },
        risk: { display_orig_portfolio },
      },
    },
    myPortfolios: { list_of_myPortfolios },
    buildPortfolio: {
      direct_review: { direct_review_portfolio },
    },
  }) => ({
    comparePortfolio,
    analyzeExistingActive,
    display_orig_portfolio,
    list_of_myPortfolios,
    direct_review_portfolio,
  }),
  (dispatch) => ({
    setOrigPortfolioDisplay: (payload) =>
      dispatch({
        type: "SET_ORIG_PORTFOLIO_DISPLAY",
        payload,
      }),
    setClientBacktestData: (payload) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_CLIENT_BACKTEST_DATA",
        payload,
      }),
    setAnalyzeAnalysisRiskStatistics: (payload) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_RISK_STATISTICS",
        payload,
      }),
    setAnalyzeAnalysisPerfHistmetrics: (payload) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_PERF_HISTMETRICS",
        payload,
      }),
    setBenchmarkName: (payload) =>
      dispatch({ type: "SET_BENCHMARKNAME", payload }),
    setDirectReviewPortfolio: (payload) =>
      dispatch({ type: "SET_DIRECT_REVIEW_PORTFOLIO", payload }),
    setMyPortfolios: (payload) =>
      dispatch({
        type: "SET_LIST_OF_MYPORTFOLIOS",
        payload,
      }),
    setReviewClientPortfolioID: (payload) =>
      dispatch({
        type: "SET_DIRECT_REVIEW_COMPARE_PORTFOLIO_ID",
        payload,
      }),
    setDirectReviewModelPortfolio: (payload) =>
      dispatch({ type: "SET_DIRECT_REVIEW_PORTFOLIO_MODELPORTFOLIO", payload }),
    resetBuildAPortfolio: () =>
      dispatch({
        type: "RESET_BUILD_A_PORTFOLIO",
      }),
    setBuildAPortfolioType: (payload) => {
      dispatch({
        type: "BUILD_A_PORTFOLIO_TYPE",
        payload,
      });
    },
    setBuildDirectReviewPortfolio: ({
      status,
      orig_id,
      scenario_id,
      optimization_params,
      asset_class,
      fund_type,
      overall_focus,
      styles,
    }) => {
      dispatch({
        type: "BUILD_DIRECT_REVIEW_PORTFOLIO",
        payload: {
          status,
          orig_id,
          scenario_id,
          optimization_params,
          asset_class,
          fund_type,
          overall_focus,
          styles,
        },
      });
    },
    resetBuildDirectReview: () => {
      dispatch({
        type: "RESET_BUILD_DIRECT_REVIEW",
      });
    },
  })
)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/pages/portfolioDashboard.jsx